import styled from 'styled-components';

const AsideHeader = styled.h5.attrs(() => ({
    className: 'mt-2 mb-3 text-primary',
}))`
`;

export default AsideHeader;
